<ng-container *ngIf="editMode">
  <p-skeleton height="32px" [width]="minWidth" styleClass="skeleton-with-border" *ngIf="!typesLoaded"></p-skeleton>
  <p-dropdown
    scrollHeight="400px"
    inputId="typesDropdown{{ guid }}"
    name="typesDropdown{{ guid }}"
    [options]="types"
    [(ngModel)]="type"
    [required]="required"
    [disabled]="disabled"
    dataKey="Id"
    [showClear]="showClear"
    [resetFilterOnHide]="true"
    [emptyFilterMessage]="'Aucun résultat'"
    appendTo="body"
    [placeholder]="placeholder"
    emptyMessage="Aucun résultat trouvé"
    [autoDisplayFirst]="false"
    [style]="pDropdownStyle"
    #typeCtrl="ngModel"
    (ngModelChange)="typeChanged()"
    *ngIf="typesLoaded"
    styleClass="no-ellipsis"
    (onFocus)="inputFocusChanged(inputFocusValue);"
    (onBlur)="inputFocusChanged(null)"
  >
    <ng-template let-item pTemplate="selectedItem">
      <span>{{ item?.Nom }}</span>
    </ng-template>
    <ng-template let-item pTemplate="item">
      <div class="ui-helper-clearfix">
        <span>{{ item.Nom }}</span>
      </div>
    </ng-template>
  </p-dropdown>
</ng-container>
<ng-container *ngIf="_type && !editMode">
  <span>{{ _type.Nom }}</span>
</ng-container>
